export const PLAYER_LONG_STEP = 5;
export const PLAYER_SHORT_STEP = 1;
export const ROOT_CLASS = 'video-player-container';
export const STEP_FORWARD = 'forward';
export const STEP_BACK = 'back';
